module.exports = __webpack_public_path__ + "img/send-to-phone.d9ae2f0d.webp";